import { useState } from "react";
import * as React from "react";
import IconTextButton from "../../../repertoire/components/iconTextButton/IconTextButton";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { ITabReduxItem } from "../../../redux/types/ITabReduxItem";
import { IMembersPortalPathInfo } from "../../types/IMembersPortalPathInfo";
import { IMembersPortalField } from "../../types/IMembersPortalField";


interface InfoToggleProps {
    headerTextItem: IMembersPortalField;
    htmlTextItem: IMembersPortalField;
    currentUserNameNumber?: string;
    lookupValues?: ILookupDictionary;
    loadMembersPortalFromPath?: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location, tabs?: ITabReduxItem[], lookupValues?: ILookupDictionary) => void;
}

const InfoToggle: React.FC<InfoToggleProps> = ({
    headerTextItem,
    htmlTextItem,
    currentUserNameNumber,
    lookupValues,
    loadMembersPortalFromPath,
}) => {
    const [open, setOpen] = useState(false);

    if (!headerTextItem || !htmlTextItem) return null;

    if (headerTextItem.hidden === true || htmlTextItem.hidden === true) return null;

    const iconClass = open
        ? "icon ms-Icon ms-Icon--ChevronUp"
        : "icon ms-Icon ms-Icon--ChevronDown";


    const handleHtmlClick = (e: any) => {
        const target = e.target as HTMLElement;
        const action = target.getAttribute("data-action");

        if (action === "menuItem" && loadMembersPortalFromPath && currentUserNameNumber) {
            e.preventDefault();
            const membersPortalPathInfo: IMembersPortalPathInfo = {
                submodule: target.getAttribute("data-id")
            };
            loadMembersPortalFromPath(membersPortalPathInfo, currentUserNameNumber, location, null, lookupValues);
        }
    };

    return (
        <div className="info-toggle-container">
            <div
                className="info-toggle-header"
                onClick={() => setOpen(!open)}
            >
                <span style={{ pointerEvents: "none" }}>
                    <IconTextButton
                        icon={iconClass}
                        text={headerTextItem?.data ?? ""}
                        disabled={false}
                    />
                </span>
            </div>

            {open && (
                <div className="info-toggle-content">
                    <div
                        onClick={handleHtmlClick}
                        dangerouslySetInnerHTML={{ __html: htmlTextItem?.data ?? "" }}
                    />
                </div>
            )}

            <div>
            </div>
        </div>
    );
};

export default InfoToggle;
